
// styled.js
import { styled, alpha } from '@mui/material/styles';
import { AppBar, Box, Button } from '@mui/material';

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.background.paper, 0.8),
  backdropFilter: 'blur(10px)',
  boxShadow: 'none',
  borderBottom: '1px solid',
  borderColor: alpha(theme.palette.divider, 0.1),
  '& .MuiToolbar-root': {
    // Hide the default menu button
    '& .MuiIconButton-edgeStart': {
      display: 'none'  // This will hide the default menu button
    }
  }
}));

export const NavButton = styled(Button)(({ theme }) => ({
  color: theme.palette.text.primary,
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    width: '0%',
    height: '2px',
    bottom: 0,
    left: '50%',
    background: theme.palette.primary.main,
    transition: 'all 0.3s ease',
    transform: 'translateX(-50%)',
  },
  '&:hover::after': {
    width: '70%',
  }
}));

export const LogoContainer = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  transition: 'transform 0.2s ease',
  '&:hover': {
    transform: 'scale(1.05)',
  }
}));

export const UserSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(1),
  },
  '& .MuiAvatar-root': {
    transition: 'transform 0.2s ease',
    '&:hover': {
      transform: 'scale(1.1)',
    }
  }
}));